import { styled as r, Box as h } from "@mui/material";
import { CurrencyTokenType as o } from "../../currency-lib/constants/currency.js";
import w from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import { useAccountContext as B } from "../../temp-lib/contexts/account/AccountContext.js";
import x from "./TokenSection.js";
import j from "./TokenSectionPopup.js";
import { useRouter as R } from "next/router";
import * as n from "ramda";
import { useState as E, useCallback as l, useMemo as d, useEffect as M } from "react";
import { useTranslation as P } from "react-i18next";
import { jsxs as f, jsx as i } from "react/jsx-runtime";
const v = r(h)`
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
`, N = r(h)`
  align-items: center;
  display: flex;
  width: 100%;
`, W = r(x)`
  .Custom-Title {
    color: #6eeae6;
  }
  background-color: #181920;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
  flex: 1;
`, _ = r(x)`
  .Custom-Title {
    color: #90ffd5;
  }
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: none;
  flex: 1;

  .Custom-Token:last-child {
    border-right: unset;
    padding-right: unset;
  }
`, z = r(w)`
  align-self: flex-end;
  color: #3682eb;
  font-size: 14px;
  margin-right: 8px;
`, Q = (k) => {
  const {
    className: b
  } = k, {
    pathname: T
  } = R(), [g, p] = E(!1), {
    account: e,
    fetchBalances: C
  } = B(), {
    t: a
  } = P(), s = l((t, A) => n.pipe(n.map((O) => n.find((c) => (c == null ? void 0 : c.type) === O, Object.values(A.balances || {}))), n.reject(n.isNil))(t), []), m = d(() => {
    const t = [o.Animus, o.Aprm, o.Stardust];
    return s(t, e);
  }, [e, s]), u = d(() => {
    const t = [o.Ron, o.WRon, o.Weth, o.Usdc, o.Anima, o.Aprs];
    return s(t, e);
  }, [e, s]), S = l(() => {
    p(!0);
  }, []), y = l(() => {
    p(!1);
  }, []);
  return M(() => {
    e.walletAddress && C();
  }, [e.walletAddress, T]), /* @__PURE__ */ f(v, {
    className: b,
    children: [/* @__PURE__ */ f(N, {
      children: [/* @__PURE__ */ i(_, {
        onChain: !0,
        displayOne: !0,
        title: a("currency_group.onchain"),
        tokens: u
      }), /* @__PURE__ */ i(W, {
        displayOne: !0,
        title: a("currency_group.offchain"),
        tokens: m
      })]
    }), /* @__PURE__ */ i(z, {
      onClick: S,
      children: `${a("common.more")} >>`
    }), /* @__PURE__ */ i(j, {
      open: g,
      onClose: y,
      offChainTokens: m,
      onChainTokens: u
    })]
  });
};
export {
  Q as default
};
//# sourceMappingURL=TokenSectionMobile.js.map
